<!--
 * @Author: wangwei
 * @Date: 2020-12-29 16:05:36
 * @LastEditTime: 2021-01-15 19:16:35
 * @LastEditors: Please set LastEditors
 * @Description: 重置密码
 * @FilePath: /java-pc/src/views/member/center/accountSafe.vue
-->
<template>
  <div class="sld_reset_password_mange">
    <MemberTitle :memberTitle="L['实名认证']"></MemberTitle>
    <div class="container">
      <!-- <div class="title">实名认证</div> -->
      <div class="manage_tips">
        <p class="tips_title">{{ L['温馨提示'] }}：</p>
        <p>• {{ L['为了保障您的账号安全，变更重要信息需进行身份验证。'] }}</p>
        <p>• {{ L['变更过程中有任何疑问请联系在线客服解决。'] }}</p>
        <p>
          •
          {{ L['如手机号/邮箱已不再使用无法获取验证码，请联系在线客服解决。'] }}
        </p>
        <p>• {{ L['复杂的密码可使账号更安全且建议定期更换密码。'] }}</p>
      </div>
      <div class="mange_con">
        <!-- <div class="without_phone_tip" v-if="!memberInfo.data.memberMobile">请先绑定手机号，再进行重置支付密码操作!</div> -->
        <!-- 重置支付密码 start -->
        <!-- <template v-if="memberInfo.data.hasPayPassword"> -->

        <div v-if="id != 1">
          <div class="lists lists1">Name:</div>
          <div class="lists">
            <input v-model="name" type="text" placeholder="Please enter" />
          </div>
          <br /><br />
          <!-- <div style="width:100%;height:30px"></div> -->
          <div class="lists lists1">ID Number:</div>
          <div class="lists">
            <input v-model="memberIdCard" type="text" placeholder="Please enter" />
          </div>
        </div>

        <div v-else>
          <div class="lists lists1">Name:</div>
          <div class="lists">{{ name2 }}</div>
          <br /><br />
          <div style="width:100%;height:30px"></div>
          <div class="lists lists1">ID Number:</div>
          <div class="lists">{{ number }}</div>
          <div style="width:100%;height:30px"></div>
          <div style="width:100%;height:30px"></div>
          <div class="lists lists1">
            <img src="../../assets/md-check_circle@1x.png" alt="" />
          </div>
          <div
            class="lists"
            style="height:60px;line-height:60px;padding-left:20px"
          >
            Certification Complete
          </div>
        </div>
        <div class="error_tip">
          <span
            v-if="errorMsg"
            style="color: #e1251b;font-size: 14px"
            class="iconfont icon-jubao"
          ></span>
          {{ errorMsg }}
        </div>
        <div
          v-if="id != 1"
          class="next flex_row_center_center pointer"
          @click="next"
        >
          Submit Certification
        </div>
        <!-- </template> -->
        <!-- 重置支付密码 end -->
      </div>
    </div>
  </div>
</template>

<script>
import { useRouter, useRoute } from 'vue-router'
import { getCurrentInstance, reactive, ref, onMounted } from 'vue'
import { useStore } from 'vuex'
import MemberTitle from '../../components/MemberTitle'

import { ElMessage } from 'element-plus'
export default {
  name: 'ResetPassword',
  components: {
    MemberTitle
  },
  setup () {
    const { proxy } = getCurrentInstance()
    const L = proxy.$getCurLanguage()
    const store = useStore()
    const sms_code = ref('')
    const number = ref('')
    const name2 = ref('')
    const id = ref('')
    const route = useRoute()
    const errorMsg = ref('')
    const memberIdCard = ref('')
    const name = ref('')
    const router = useRouter()
    const password = ref('') //输入新密码
    const confirm_password = ref('') //再次输入新密码
    const old_password = ref('') //输入旧密码
    // const confirm_password = ref("");
    const timeOutId = ref('') //定时器的返回值
    const countDownM = ref(0) //短信验证码倒计时
    const memberInfo = reactive({ data: store.state.memberInfo })

    onMounted(() => {
      id.value = route.query.id
      number.value = route.query.number
      name2.value = route.query.name
      // console.log(route.query.id,route.query.number,route.query.name)
    })
    const getSmsCode = () => {
      if (countDownM.value) {
        return false
      }
      var param = {}
      param.verifyType = 2
      param.verifyAddr = memberInfo.data.memberMobile
      proxy.$get('v3/msg/front/commons/sendVerifyCode', param).then(res => {
        if (res.state == 200) {
          countDownM.value = 60
          countDown()
        }
      })
    }
    const next = () => {
      var param = {}
      param.memberTrueName = name.value
      param.memberIdCard = memberIdCard.value
      proxy.$post('v3/member/front/memberAttest/doAttest', param).then(res => {
        console.log(1111, res)
        ElMessage(res.msg)
        setTimeout(() => {
          if (res.state == 200) {
            router.replace({
              path: '/member/index'
            })
          }
        }, 2000)
      })
    }
    //倒计时
    const countDown = () => {
      countDownM.value--
      if (countDownM.value == 0) {
        clearTimeout(timeOutId.value)
      } else {
        timeOutId.value = setTimeout(countDown, 1000)
      }
    }
    return {
      L,
      memberInfo,
      countDownM,
      getSmsCode,
      next,
      password,
      old_password,
      memberIdCard,
      name,
      confirm_password,
      sms_code,
      errorMsg,
      route,
      number,
      name2,
      id
    }
  }
}
</script>

<style lang="scss" scoped>
.sld_reset_password_mange {
  width: 1007px;
  float: left;
  margin-left: 10px;

  .container {
    background-color: white;
    width: 100%;
    box-sizing: border-box;
    border: 1px solid #eaeaea;
    padding: 25px 40px;
    .manage_tips {
      width: 938px;
      // background: #fffdee;
      // border: 1px solid #edd28b;
      padding: 15px 36px;
      // margin-top: 117px;
      p {
        color: #555555;
        margin-top: 10px;
      }
      .tips_title {
        font-weight: bold;
        margin-bottom: 11px;
        margin-top: 0;
      }
    }
    .title {
      font-size: 18px;
      border-bottom: 1px dashed #eaeaea;
      padding-bottom: 25px;
      font-weight: 600;
      margin-bottom: 20px;
    }

    .mange_con {
      width: 100%;
      margin: 62px auto 0;
      margin-left: 120px;

      .current {
        line-height: 56px;
        font-size: 14px;
        color: #000000;
      }
      .error_tip {
        height: 15px;
        margin-top: 10px;
        color: #f30213;
        i {
          margin-right: 10px;
        }
      }
      .without_phone_tip {
        line-height: 56px;
        font-size: 16px;
        color: $colorMain2;
      }

      .sms_code_con {
        width: 100%;

        .get_sms {
          width: 100px;
          height: 40px;
          line-height: 38px;
          background: #e73539;
          text-align: center;
          color: white;
          font-size: 14px;
          border-radius: 0 3px 3px 0;
        }
      }

      .margin {
        margin-top: 20px;
      }

      .next {
        width: 524px;
        height: 68px;
        background: #6784fc;
        color: #fff;
        font-size: 18px;
        font-weight: bold;
        text-align: center;
        color: white;
        margin-top: 20px;
        line-height: 40px;
        border-radius: 3px;
        margin: 22px auto 20px;
        margin-left: 100px;
      }
    }
  }
}
</style>
<style lang="scss">
.sld_reset_password_mange {
  .el-input {
    width: 280px;
    height: 40px;
    border-radius: 3px 0 0 3px;
  }
  .el-input__inner {
    width: 280px;
    height: 40px;
    border-radius: 3px 0 0 3px;
  }
  .input {
    width: 100%;
    height: 40px;
    margin-top: 20px;
    border-radius: 3px;
    .el-input__inner {
      height: 40px;
      border-radius: 3px;
      width: 100%;
    }
  }
}
.lists {
  // float: left;
  line-height: 60px;
  font-size: 16px;
}
.lists input {
  width: 524px;
  height: 68px;
  padding: 0 10px;
}
.lists1 {
  float: left;
  width: 100px;
  text-align: right;
}
</style>
